import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { number } from "prop-types";
import { Link } from "@quintype/components";

import { getSponsorObj } from "../../helper/api";

import "./sponsorDetails.m.css";

const SponsorDetails = ({ sponsorId }) => {
  const [sponsors, setSponsors] = useState([]);
  const [sponsorsLogo, setSponsorsLogo] = useState([]);
  const fetchSponsorObjects = async () => {
    const sponsorObj = await getSponsorObj(sponsorId);
    const sponsorPhoto = get(sponsorObj, ["photo", "0", "url"], null);
    setSponsors(sponsorObj);
    setSponsorsLogo(sponsorPhoto);
  };
  useEffect(() => {
    fetchSponsorObjects();
  }, [sponsorId]);
  return (
    <div styleName="base">
      {sponsors.url ? (
        <Link href={sponsors.url} target="_blank" rel="noindex nofollow">
          <div styleName="sponsor-details">
            <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
            <div>
              <div styleName="sponsor-name">{sponsors.title}</div>
              <div styleName="sponsor-type">Paid partnership</div>
            </div>
          </div>
        </Link>
      ) : (
        <div styleName="sponsor-details">
          <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
          <div>
            <div styleName="sponsor-name">{sponsors.title}</div>
            <div styleName="sponsor-type">Paid partnership</div>
          </div>
        </div>
      )}
    </div>
  );
};

SponsorDetails.propTypes = {
  sponsorId: number,
};

export default SponsorDetails;
